import type { InviteStatus, ProfileStatus, TenantStatus } from "../types/admin";

export function formatDate(value: string | null | undefined) {
  if (!value) {
    return "Not set";
  }

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(value));
}

export function formatDateTime(value: string | null | undefined) {
  if (!value) {
    return "Not set";
  }

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function statusTone(
  status: TenantStatus | InviteStatus | ProfileStatus | string,
) {
  if (["active", "accepted"].includes(status)) return "success";
  if (["trial", "pending", "invited", "onboarding"].includes(status)) return "warning";
  if (["suspended", "cancelled", "expired", "disabled"].includes(status)) {
    return "danger";
  }
  return "neutral";
}

export function titleCase(value: string) {
  return value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}
